import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { SmartStreamStore } from "./SmartStreamStore";

const SmartStreamContext = createContext<SmartStreamStore<any, any> | null>(null);

export function SmartStreamProvider({
  store,
  children,
}: {
  store: SmartStreamStore<any, any>;
  children: ReactNode;
}) {
  return (
    <SmartStreamContext.Provider value={store}>
      {children}
    </SmartStreamContext.Provider>
  );
}

/**
 * Get the raw store from context. Generic parameter lets callers recover type safety:
 *
 *   const store = useLanggraphStreamContext<MyState>();
 *   // store is SmartStreamStore<MyState>
 *
 * The context itself is untyped (any, any) because the provider doesn't know
 * the state type. The generic is a safe cast — the caller knows what state
 * type was passed to Chat.Root / useLanggraphStream.
 */
export function useLanggraphStreamContext<
  StateType extends Record<string, unknown> = Record<string, unknown>,
>(): SmartStreamStore<StateType> {
  const store = useContext(SmartStreamContext);
  if (!store) {
    throw new Error(
      "useLanggraphStreamContext must be used within a <SmartStreamProvider>"
    );
  }
  return store as SmartStreamStore<StateType>;
}
